export function setGolfFavicon(): void {
  const size = 128;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2;

  // ── Background circle: deep forest green radial gradient ──
  const bgGrad = ctx.createRadialGradient(cx - 10, cy - 10, 4, cx, cy, r);
  bgGrad.addColorStop(0, '#22583a');
  bgGrad.addColorStop(1, '#0d2e1c');
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fillStyle = bgGrad;
  ctx.fill();

  // ── Thin gold ring border ──
  ctx.beginPath();
  ctx.arc(cx, cy, r - 3, 0, Math.PI * 2);
  ctx.strokeStyle = '#c9a84c';
  ctx.lineWidth = 3;
  ctx.stroke();

  // ── Golf ball (white circle) ──
  const ballX = cx - 14;
  const ballY = cy + 10;
  const ballR = 26;

  // Ball shadow
  ctx.beginPath();
  ctx.arc(ballX + 3, ballY + 3, ballR, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(0,0,0,0.25)';
  ctx.fill();

  // Ball body
  const ballGrad = ctx.createRadialGradient(ballX - 8, ballY - 8, 2, ballX, ballY, ballR);
  ballGrad.addColorStop(0, '#ffffff');
  ballGrad.addColorStop(0.6, '#f0f0f0');
  ballGrad.addColorStop(1, '#d8d8d8');
  ctx.beginPath();
  ctx.arc(ballX, ballY, ballR, 0, Math.PI * 2);
  ctx.fillStyle = ballGrad;
  ctx.fill();

  // Dimples
  const dimples: [number, number][] = [
    [ballX - 10, ballY - 8],
    [ballX + 4, ballY - 12],
    [ballX + 14, ballY - 4],
    [ballX - 16, ballY + 4],
    [ballX - 4, ballY + 6],
    [ballX + 10, ballY + 8],
    [ballX - 10, ballY + 16],
    [ballX + 4, ballY + 18],
  ];
  dimples.forEach(([dx, dy]) => {
    ctx.beginPath();
    ctx.arc(dx, dy, 2.5, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(0,0,0,0.1)';
    ctx.fill();
  });

  // ── Flag pole ──
  const poleX = cx + 22;
  const poleTopY = cy - 36;
  const poleBottomY = cy + 38;

  ctx.beginPath();
  ctx.moveTo(poleX, poleTopY);
  ctx.lineTo(poleX, poleBottomY);
  ctx.strokeStyle = '#c9a84c';
  ctx.lineWidth = 3.5;
  ctx.lineCap = 'round';
  ctx.stroke();

  // ── Flag pennant ──
  ctx.beginPath();
  ctx.moveTo(poleX, poleTopY);
  ctx.lineTo(poleX + 26, poleTopY + 14);
  ctx.lineTo(poleX, poleTopY + 28);
  ctx.closePath();
  ctx.fillStyle = '#c9a84c';
  ctx.fill();

  // ── Apply as favicon ──
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = 'image/png';
  link.href = canvas.toDataURL('image/png');
}
